import React from 'react';
import styled from 'styled-components';
import { cssSpacing, IconEmail } from '@spotify-internal/encore-web';
import { TypeWithMargin } from '@components/shared/styles';
import { formBodyHeight } from './constants';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: ${formBodyHeight};
`;

interface SuccessStateProps {
  title: string;
  text: string;
}

export const SuccessState = ({ title, text }: SuccessStateProps) => {
  return (
    <Content>
      <IconEmail
        iconSize={32}
        data-cy="success-state"
        data-testid="email-icon"
      />
      <TypeWithMargin
        variant="celloCanon"
        semanticColor="textBase"
        marginBottom={cssSpacing('tighter-2', '16px')}
        marginTop={cssSpacing('tighter-2', '16px')}
      >
        {title}
      </TypeWithMargin>
      <TypeWithMargin variant="viola" semanticColor="textBase">
        {text}
      </TypeWithMargin>
    </Content>
  );
};
